module.exports = __webpack_public_path__ + "static/media/Twitter-icon-small.9f7450b6.png";